import callbacks from './callbacks';

/**
 * Выбор нужного события
 */
function _selectEvent (evtName) {
  // Если передали не строку или пустую строку, выходим
  if (typeof evtName !== 'string' || !evtName) {
    return;
  }

  const self = this;
  let _thatEvent = self.eventsList[evtName];

  // Если у нас новое событие, создаем его и объявляем в системе
  if (!_thatEvent) {
    _thatEvent = callbacks();
    self.eventsList[evtName] = _thatEvent;
  }

  return _thatEvent;
}

export default _selectEvent;
